import { createSlice } from '@reduxjs/toolkit';
import { buildAsyncReducers } from '../thunkTemplate';
import { organizations as initialState } from '../initialState';

import { getOrganizations, putOrganization } from './_organizations';

// NOTE: "Mutating" state is safe in redux toolkit because it uses Immer
const { reducer } = createSlice({
  name: 'organizations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [getOrganizations, putOrganization]);
  },
});

// Export the reducer, either as a default or named export
export { getOrganizations, putOrganization };
export default reducer;
